"use client";
import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { cva as t } from "class-variance-authority";
import { cn as o } from "./index15.js";
const d = t("animate-spin rounded-full border-2 border-border border-t-brand-primary", {
  variants: {
    size: {
      sm: "h-4 w-4",
      default: "h-6 w-6",
      lg: "h-8 w-8"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function p({ className: e, size: n, label: a = "Loading...", ...s }) {
  return /* @__PURE__ */ i("div", { role: "status", ...s, children: [
    /* @__PURE__ */ r("div", { className: o(d({ size: n }), e) }),
    /* @__PURE__ */ r("span", { className: "sr-only", children: a })
  ] });
}
export {
  p as Spinner
};
//# sourceMappingURL=index13.js.map
